// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__gDrtC {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.styles_navWrapper__WSL8\\+ {
  width: 100%;
  max-width: 400px;
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/components/CardNavNew/styles.module.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADF;;AAIA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;AADF","sourcesContent":["@import './src/assets/styles/variables/colors';\n\n.wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.navWrapper {\n  width: 100%;\n  max-width: 400px;\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__gDrtC`,
	"navWrapper": `styles_navWrapper__WSL8+`
};
export default ___CSS_LOADER_EXPORT___;
